import { FEATURE_SLICE_COLORS, OTHER_SLICE_CODE, OTHER_SLICE_COLOR } from './constants';
import type { FeatureUsageItem, FeatureUsageParams } from './types';

const DAY_MS = 86_400_000;

const toUtcDay = (date: Date) => date.toISOString().slice(0, 10);

/** Inclusive range of `days` UTC days ending today, in the form the API expects. */
export const buildRangeParams = (days: number, groupBy: FeatureUsageParams['groupBy']) => {
  const now = Date.now();
  return {
    from: toUtcDay(new Date(now - (days - 1) * DAY_MS)),
    to: toUtcDay(new Date(now)),
    groupBy,
  };
};

export const sliceColor = (item: FeatureUsageItem, index: number) =>
  item.code === OTHER_SLICE_CODE
    ? OTHER_SLICE_COLOR
    : FEATURE_SLICE_COLORS[index % FEATURE_SLICE_COLORS.length];

/** conic-gradient stops for the donut; slices with zero calls are skipped. */
export const buildDonutGradient = (items: FeatureUsageItem[], total: number) => {
  let cursor = 0;
  const stops = items
    .map((item, index) => ({ item, index }))
    .filter(({ item }) => item.count > 0)
    .map(({ item, index }) => {
      const start = cursor;
      cursor += (item.count / total) * 100;
      return `${sliceColor(item, index)} ${start}% ${cursor}%`;
    });
  return `conic-gradient(${stops.join(', ')})`;
};
